import { BaseClient, IBatch, IBatchQuery, ISaveBatch, logisticsApi } from '../../shared';

class BatchesClient extends BaseClient<IBatch, ISaveBatch, IBatchQuery> {
    constructor() {
        super(logisticsApi, '/batches');
    }
}

export const batchesClient = new BatchesClient();
